module.exports = __webpack_public_path__ + "static/media/arctic.3a55d91b.png";